import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cpfCnpj'
})
export class CpfCnpjPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    value = value.replace(/\D/g, ''); // Remove caracteres não numéricos

    if(value == null){
      return ` - `;
    }

    if (value.length === 11) { // CPF
      return `${value.substring(0, 3)}.${value.substring(3, 6)}.${value.substring(6, 9)}-${value.substring(9)}`;
    } else if (value.length === 14) { // CNPJ
      return `${value.substring(0, 2)}.${value.substring(2, 5)}.${value.substring(5, 8)}/${value.substring(8, 12)}-${value.substring(12)}`;
    }

    return value; // Retorna o valor sem formatação se não for nem CPF nem CNPJ
  }
}
